import type { FC } from 'react';
import React from 'react';

import { NavTree } from '../NavTree/NavTree';
import type { NavigationProps } from '../../Navigation';
import { ThemeSwitcher } from '../ThemeSwitcher/ThemeSwitcher';
import { ResizableAside } from '../ResizableAside/ResizableAside';
import { NavMenuWrapper, NavPanel, NavScroll, NavWrapper, ThemeSwitcherWrapper } from '../../Navigation.styles';

export const NavigationSimple: FC<NavigationProps> = ({ navTree, activeDocMeta, resizable }) => {
  const [scrolled, setScrolled] = React.useState(false);

  const handleScroll = () => {
    setScrolled(window.scrollY > 72);
  };

  React.useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navigation = (
    <NavWrapper>
      <NavScroll $scrolled={scrolled}>
        <NavMenuWrapper>
          <NavPanel>
            <NavTree isOpened navTree={navTree} activeDocMeta={activeDocMeta} />
          </NavPanel>
        </NavMenuWrapper>
        <ThemeSwitcherWrapper>
          <ThemeSwitcher />
        </ThemeSwitcherWrapper>
      </NavScroll>
    </NavWrapper>
  );

  return resizable ? <ResizableAside>{navigation}</ResizableAside> : navigation;
};
